import useResource from "./useResource"
import { useSWRConfig } from "swr"
import { handleMoveChildren } from "web/components/Reorderable/ReorderChildrenHelper"
import API from "web/hooks/data/api"

export default function useOverview({ overviewFetchParams, params }) {
  const {
    overviewId: id,
    type,
    overviewKey,
    parentKeys = [],
  } = overviewFetchParams

  const { cache, mutate } = useSWRConfig()

  const [overview] = useResource({
    key: overviewKey,
    parentKeys,
    params,
  })

  const refreshKeys = parentKeys.concat(overviewKey)

  function reset() {
    cache.delete(overviewKey)
    for (const key of cache.keys()) {
      // tileMapKey
      if (
        key.includes(`overviews/${id}/tile_maps`) ||
        key.includes("overview/tile_maps")
      ) {
        cache.delete(key)
        continue
      }
      // tileKey
      if (
        key.includes(`overviews/${id}/tile_`) ||
        key.includes("overview/tile_")
      ) {
        mutate(key)
      }
    }
    type === "viewable" && mutate(overviewKey)
  }

  function refreshViewableOverviewAndTiles({ reset } = { reset: false }) {
    overview.refresh()
    for (const key of cache.keys()) {
      if (reset && key.includes("overview/tile_maps")) {
        cache.delete(key)
        continue
      }
      if (key.includes("overview/tile_")) {
        mutate(key)
      }
    }
  }

  function handleMoveTile(prevPos, newPos) {
    handleMoveChildren({
      prevPos: prevPos,
      newPos: newPos,
      mainObj: overview,
      movingObjs: overview.tiles,
      idName: "id",
      firstLayer: type,
      secondLayer: "tile_entries_attributes",
    })
  }

  function handleResizeTile(index, width, height) {
    if (!overview.tiles.length) return
    const tile_id = overview.tiles[index].id
    overview.update({
      overview: {
        tile_entries_attributes: { id: tile_id, height: height, width: width },
      },
    })
  }

  async function handleTemplateReset() {
    await overview.update({
      overview: {
        modified_from_template: false,
      },
    })
    reset()
  }

  async function addTile(routeSuffix, data = {}) {
    const path = `${overviewKey}/tile_${routeSuffix}`

    await API.post(path, data)
    for (const parentKey of parentKeys) {
      await mutate(parentKey)
    }
    return await mutate(overviewKey)
  }

  return {
    ...overview,
    refreshViewableOverviewAndTiles,
    reset,
    key: overviewKey,
    type,
    handleTemplateReset,
    handleResizeTile,
    handleMoveTile,
    addTile,
    refreshKeys,
  }
}
